import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type SessionService from 'scaleflow/services/session';
import type OrganisationService from 'scaleflow/services/organisation';
import type StoreService from 'scaleflow/services/store';
import ENV from 'scaleflow/config/environment';
import { initializeVdrClient } from 'scaleflow/utils/aws-clients/s3VDRClient';

export default class DataListController extends Controller {
  @service declare session: SessionService;
  @service declare organisation: OrganisationService;
  @service declare store: StoreService;

  queryParams = ['search'];

  @tracked search = '';

  get tenantId() {
    return this.session.activeTenantId;
  }

  /**
   * The framed app needs this at mount, before it can ask for credentials, so
   * it travels with the context rather than with the credentials.
   */
  get vdrBucket() {
    return ENV.storage.AWSS3.vdr_bucket;
  }

  get sourceURL() {
    return `${ENV.vdr.url}/data/list`;
  }

  /**
   * Answers the framed app's credential requests. It holds no token and mints
   * nothing itself — see
   * `docs/superpowers/specs/2026-08-28-vdr-iframe-credentials-design.md`.
   */
  @action
  async provideCredentials() {
    const client = await initializeVdrClient(this.store);
    return client.getCredentials();
  }
}
